import { TitleWrapper } from './title.component';

export * from './title.component';
export default TitleWrapper;

TitleWrapper.define('der-ui-title-wrapper');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-title-wrapper': TitleWrapper;
    }
}
